<template>
  <div class="countdown">
    <el-button
      class="getNumber"
      @click="getCode"
      >
    {{ codeMsg }}
    </el-button>
  </div>
</template>

<script>
import { pictureVerification } from '@/scripts/captcha'
export default {
  name: 'CountDown',
  props: {
    form: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      codeDisabled: true,
      codeMsg: '下一步'
    }
  },
  watch: {
  },
  methods: {
    async getCode() {
      if (this.isNull(this.form.oldEmailPassword)) {
        this.$emit('logInClickBtn')
        return false
      }
      if (this.isNull(this.form.firstEmailPassword)) {
        this.$emit('logInClickBtn')
        return false
      }
      if (this.isNull(this.form.secondEmailPassword)) {
        this.$emit('logInClickBtn')
        return false
      }
      await this.checkCaptcha(this.form)
      this.$emit('logInClickBtn')
    },
    async checkCaptcha(form) {
      try {
        const res = await pictureVerification()
        form.captcha = {
          ticket: res.ticket,
          randStr: res.randstr
        }
      }
      catch (error) {
        console.log('checkCaptcha:', error)
        this.$message({
          message: '图形验证码错误',
          type: 'error'
        })
        this.$emit('handleClick', false)
        throw new Error('图形验证码错误')
      }
    },
    isNull(str) {
      if (str === '') return true
      var regu = '^[ ]+$'
      var re = new RegExp(regu)
      return re.test(str)
    }
  }
}
</script>

<style lang="less" scoped>
  .countdown {
    .getNumber{
      width: 96px;
      height: 36px;
      background: #4D78FF;
      border-radius: 18px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
    }
  }
</style>
